import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material"
import { ReactComponent as CheckListIcon } from "../../../assets/imgs/icons/checkList.svg"
import { ReactComponent as AccessibilityIcon } from "../../../assets/imgs/icons/accesibility.svg"
import { ReactComponent as FoodAndBeveragesIcon } from "../../../assets/imgs/icons/foodAndBeverages.svg"

export default function VenueIncluded({ tenant }) {
  const branch = tenant?.data?.branches[0]
  const whatsIncluded = branch?.whats_included || {}

  const sections = [
    {
      title: "Amenities",
      icon: <CheckListIcon sx={{ fontSize: 20 }} />,
      items: whatsIncluded.amenities || branch?.amenities || [],
    },
    {
      title: "Accessibility",
      icon: <AccessibilityIcon sx={{ fontSize: 20 }} />,
      items:
        whatsIncluded.accessibility || branch?.accessibility_features || [],
    },
    {
      title: "Food and Beverages",
      icon: <FoodAndBeveragesIcon sx={{ fontSize: 20 }} />,
      items:
        whatsIncluded.food_and_beverages || branch?.food_beverages || [],
    },
  ]

  const includedTitleSx = {
    color: "text.primary",
    fontWeight: 700,
    fontSize: "16px",
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Typography
        sx={{
          color: "text.heading",
          fontWeight: 700,
          fontSize: "18px",
          mb: 2,
        }}
      >
        What’s Included
      </Typography>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "repeat(3, 1fr)" },
          gap: 3,
          mb: 2,
        }}
      >
        {sections.map((section, idx) => (
          <Box key={idx}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              {section.icon}
              <Typography sx={includedTitleSx}>{section.title}</Typography>
            </Box>

            <List sx={{ pl: 2, py: 0 }}>
              {section.items.map((item, i) => (
                <ListItem
                  key={i}
                  disableGutters
                  sx={{
                    py: 0.3,
                  }}
                >
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          color: "text.subcaption",
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                      >
                        {item}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
          </Box>
        ))}
      </Box>

      <Divider sx={{ my: 2 }} />
    </Box>
  )
}
